export function getIsStripeCompletedByDriverProfile(driverProfile = {}) {
  return Boolean(
    driverProfile?.stripe_requirements?.length === 0 &&
      driverProfile?.stripe_payouts_enabled &&
      driverProfile?.stripe_details_submitted,
  );
}
